import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import _get from 'hs-lodash/get';
import { useContext } from 'react';
import { propertyFieldTypes } from '../../../constants/properties';
import { AppContext } from '../../../contexts/app/context';
import { CancelUIIconWrapper, IconsContainer, SuccessUIIconWrapper } from './EditControls.style';
import { EditIcon } from 'foundations-assets/icons/components/EditIcon';
import { RemoveIcon } from 'foundations-assets/icons/components/RemoveIcon';
import { SuccessIcon } from 'foundations-assets/icons/components/SuccessIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function EditControls({
  currentProperty,
  isEdit,
  isLoading,
  errorMessage,
  propertyValidationError,
  cancelEdit,
  canSave,
  startEdit,
  saveHandler,
  isHover
}) {
  const {
    isPastMeeting,
    appName
  } = useContext(AppContext);
  if (isPastMeeting) return null;
  if (!currentProperty) return null;
  // we don`t support for editting input of type file
  if (_get(currentProperty, 'fieldType', '') === propertyFieldTypes.file) return null;
  if (_get(currentProperty, 'modificationMetadata.readOnlyValue', false) || _get(currentProperty, 'calculated')) return null;
  if (isEdit && isLoading) return /*#__PURE__*/_jsxs(IconsContainer, {
    errorMessage: errorMessage || propertyValidationError,
    children: [/*#__PURE__*/_jsx(LoadingSpinner, {
      size: "extra-small",
      minHeight: 8
    }), /*#__PURE__*/_jsx(CancelUIIconWrapper, {
      children: /*#__PURE__*/_jsx(IconButton, {
        onClick: cancelEdit,
        "data-test-id": `${appName}-cancel-edit-button-${currentProperty.name}`,
        use: "transparent",
        size: "small",
        children: /*#__PURE__*/_jsx(RemoveIcon, {})
      })
    })]
  });
  if (isEdit) return /*#__PURE__*/_jsxs(IconsContainer, {
    errorMessage: errorMessage || propertyValidationError,
    children: [/*#__PURE__*/_jsx(SuccessUIIconWrapper, {
      canSave: canSave,
      children: /*#__PURE__*/_jsx(IconButton, {
        onClick: saveHandler,
        "data-test-id": `${appName}-save-edit-button-${currentProperty.name}-${canSave ? 'enable' : 'disable'}`,
        use: "transparent",
        size: "small",
        children: /*#__PURE__*/_jsx(SuccessIcon, {})
      })
    }), /*#__PURE__*/_jsx(CancelUIIconWrapper, {
      children: /*#__PURE__*/_jsx(IconButton, {
        onClick: cancelEdit,
        "data-test-id": `${appName}-cancel-edit-button-${currentProperty.name}`,
        use: "transparent",
        size: "small",
        children: /*#__PURE__*/_jsx(RemoveIcon, {})
      })
    })]
  });
  return /*#__PURE__*/_jsx(IconsContainer, {
    opacity: isHover ? 1 : 0,
    marginTop: -6,
    children: /*#__PURE__*/_jsx(IconButton, {
      use: "transparent",
      onClick: startEdit,
      "data-test-id": `${appName}-start-edit-button-${currentProperty.name}`,
      children: /*#__PURE__*/_jsx(EditIcon, {
        size: "200"
      })
    })
  });
}
export default EditControls;